// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"23f80b8d","301":"92506244","541":"a0bc2aa2","571":"49522f31"}[chunkId] + ".chunk.css";
};